import { FlowName } from '../../../../../@types/flow-types'
import { ContentStateInterface } from '../../../../../@types/types'

const NEW_OBJECT_PARAM = 'newObject'
const CONSTRUCTION_YEAR_UNKNOWN_PARAM = 'constructionYearUnknown'

const getTrimmedValue = (searchParams: URLSearchParams, name: string): string | undefined => {
  const value = searchParams.get(name)?.trim()
  return value ? value : undefined
}

const normalizeDecimal = (value: string | undefined): string | undefined => {
  if (!value || !/^\d+(?:[.,]\d{1,2})?$/.test(value)) {
    return undefined
  }

  return value.replace('.', ',')
}

const parsePositiveNumber = (value: string | undefined): number | undefined => {
  const normalizedValue = normalizeDecimal(value)
  if (!normalizedValue) {
    return undefined
  }

  const parsedValue = Number(normalizedValue.replace(',', '.'))
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : undefined
}

const parseConstructionYear = (value: string | undefined): number | undefined =>
  value && /^[1-9]\d{3}$/.test(value) ? Number(value) : undefined

export const getPropertyOwnerApartmentRentPrefill = (
  searchParams: URLSearchParams,
  flowName: FlowName,
  listingId?: string
): ContentStateInterface => {
  if (
    flowName !== FlowName.PROPERTY_OWNER_APARTMENT_RENT ||
    listingId !== undefined ||
    searchParams.get(NEW_OBJECT_PARAM) !== 'true'
  ) {
    return {}
  }

  const street = getTrimmedValue(searchParams, 'street')
  const houseNumber = getTrimmedValue(searchParams, 'houseNumber')
  const postcode = getTrimmedValue(searchParams, 'zip')
  const city = getTrimmedValue(searchParams, 'city')
  const livingSpace = normalizeDecimal(getTrimmedValue(searchParams, 'livingArea'))
  const price = parsePositiveNumber(getTrimmedValue(searchParams, 'coldRent'))
  const unknownConstructionYear = searchParams.get(CONSTRUCTION_YEAR_UNKNOWN_PARAM) === 'true'
  const constructionYear = unknownConstructionYear
    ? undefined
    : parseConstructionYear(getTrimmedValue(searchParams, 'constructionYear'))

  return {
    ...(street && { street }),
    ...(houseNumber && { houseNumber }),
    ...(postcode && { postcode }),
    ...(city && { city }),
    ...(livingSpace && { livingSpace }),
    ...(price !== undefined && { price }),
    ...(constructionYear !== undefined && { constructionYear }),
    ...(unknownConstructionYear && { unknownConstructionYear: true }),
  }
}

export const hasCompletePrefilledAddress = (prefill: ContentStateInterface): boolean =>
  !!(prefill.street && prefill.houseNumber && prefill.postcode && prefill.city)
